<template>
    <el-radio-group v-model="selNode">
        <p v-for="(item, index) in nodes" :key="index" style="margin-bottom:10px;">
            <el-radio :label="item.sqe">{{ item.name }}</el-radio>
        </p>
    </el-radio-group>
</template>

<script>
export default {
    data: function(){
        return {
            selNode: null,
            nodes: []
        }
    },
    props: {
        name: String
    },
    methods: {
        submit: function (onValid, onSuccess, onFailed, onComplete) {
           if(this.selNode === null){
               this.$message.error('请选择节点');
           }else{
               onValid(this.selNode);
           }
        }
    },
    mounted: function(){
        this.$httpPost('RechargeManage/Recharge/GetHtProcedureEntry', { name: this.name }).then(res=>{
            this.nodes = res.datalist;
        })
    }
}
</script>

<style>

</style>